import React from "react";
import { connect } from "react-redux";

import gnpGeneral from "./../gnp-general.css";
//import gnpOlvide from "./gnp-olvide.css";
import IngresaCorreo from "./ingresaCorreo.cmpt";
import IngresaCorreoMovil from "./ingresaCorreoMovil.cmpt";
import RevisaCorreo from "./revisaCorreo.cmpt";
import UsuarioBloqueado from "./usuarioBloqueado.cmpt";
import UsuarioBloqueadoMovil from "./usuarioBloqueadoMovil.cmpt";


const mapState = (state) => {
	return {
		loading: state.global.loading,
		paso: state.olvide.paso,
		dispositivo: state.global.dispositivo
	};
};

const mapDispatch = (dispatch) => {
	return {
		siguientePaso: (iPaso) => {
			dispatch({ "type": "OLVIDE_PASO_SIGUIENTE", paso: iPaso});
		}
	};
};

class Flujo extends React.Component {
	siguiente = () => {
		this.props.siguientePaso(this.props.paso + 1);
	}
	
	render() {
		console.log("olvide dispositivo",this.props.dispositivo);
		const { dispositivo } = this.props;
		
			return dispositivo === "app"  ? 
			<div>
				<div>
					{ (this.props.paso == 0 || this.props.paso == 1) && 
						<IngresaCorreoMovil  paso={this.props.paso}/>
					}
					{/* { this.props.paso ==  1 && 
						<RevisaCorreo />
					} */}
					{ this.props.paso == "bloqueado" &&
						<UsuarioBloqueadoMovil/>
					}
				</div>
			</div>
			:
			<div className="gnp-generales loginGNP">
				<div className="content">
				{ this.props.paso == 0 && 
					<IngresaCorreo />
				}
				{ this.props.paso == 1 && 
					<RevisaCorreo />
				}
				{ this.props.paso == "bloqueado" &&
					<UsuarioBloqueado/>
				}
				</div>
			</div>
	}
}

export default connect(mapState, mapDispatch)(Flujo);


// WEBPACK FOOTER //
// ./src/gnp-olvide/flujo.cmpt.js